import {Button, Divider, IconButton, Paper, Typography} from '@yandex-delivery/blocks'
import {Image} from '@yandex-delivery/blocks/image'
import {useI18n} from '@yandex-delivery/core/i18n'
import clsx from 'clsx'
import {forwardRef} from 'react'

import {tagToUrl} from '../../lib/tagToUrl'
import {DraggableAddresses} from './components/draggable-addresses/DraggableAddresses'
import * as styles from './RouteInfo.classes'
import type {AddressInfoProps} from './RouteInfo.types'

// тег кнопки закрытия
const CROSS_SLUG = 'delivery_form_cross_fill'

/**
 * Компонент с текущим отмеченным адресом и кнопкой сохранения.
 */
export const RouteInfo = forwardRef(function RouteInfo(
  {addresses, setAddresses, onSave, onClose, fullscreen = false}: AddressInfoProps,
  ref,
) {
  const i18n = useI18n()

  return (
    <Paper
      ref={ref}
      className={clsx({[styles.fullscreenRouteInfoContainer]: fullscreen})}
      flexDirection="column"
      float={fullscreen ? 'top' : 'bottom'}
    >
      <Paper item="header" px="m" py="l">
        <div className={styles.header}>
          <Typography thickness="medium" variant="body1">
            {i18n('bdui.route.title', 'Маршрут')}
          </Typography>

          {fullscreen && onClose && (
            <IconButton className={styles.closeButton} onClick={onClose} variant="ghost">
              <Image height={24} src={tagToUrl(CROSS_SLUG)} />
            </IconButton>
          )}
        </div>
      </Paper>
      <Divider />
      <DraggableAddresses addresses={addresses} fullscreen={fullscreen} setAddresses={setAddresses} />
      <Paper className={styles.footer} float={fullscreen ? 'bottom' : undefined} item="footer" pb="s" px="s">
        <Button onPress={onSave} size="l" variant="action" fullWidth>
          {i18n('bdui.route.ready', 'Готово')}
        </Button>
      </Paper>
    </Paper>
  )
})
